/* @flow */
import apiRequest from 'lib/apiRequest';

const AppLinkActions = {
  sendLink(phoneNumber: string) {
    return apiRequest('/devices/sms/send_app_link', 'POST', {
      endpoint: phoneNumber,
    });
  },
  sendIndividualPlanAppLink(phoneNumber: string) {
    return apiRequest('/devices/sms/send_individual_plan_link', 'POST', {
      endpoint: phoneNumber,
    });
  },
};

export default AppLinkActions;
